jQuery(document).ready(function() {
    // Función que se ejecutará cuando el elemento esté disponible
    function initializeFaqSection() {
        jQuery("faq-section div > img").attr("srcset", "");

        jQuery("faq-section ul > li:nth-child(1)").on('click', 'a', function (e) {
            e.preventDefault();
            let img = jQuery("faq-section div > img");
            img.attr("srcset", "").attr("src", "https://cdn.shopify.com/s/files/1/0919/5166/1329/files/2FOTO_PANAL_2.webp?v=1743532157");
        });

        jQuery("faq-section ul > li:nth-child(2)").on('click', 'a', function (e) {
            e.preventDefault();
            let img = jQuery("faq-section div > img");
            if (img.length) {
                img.attr("srcset", "").attr("src", "https://cdn.shopify.com/s/files/1/0919/5166/1329/files/2FOTO-TOALLITAS.webp?v=1742514189");
            }
        });
    }

    // Observador para detectar cuándo se agrega faq-section al DOM
    const observer = new MutationObserver((mutationsList, observer) => {
        if (jQuery("faq-section").length > 0) {
            initializeFaqSection();
            observer.disconnect(); // Detiene la observación
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});